import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, ModalController, NavController, NavParams } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { ResultEditPreRoundPage } from '../../edits/pre-round/edit-pre-round';

@Component({
  selector: 'result-group-ko',
  templateUrl: 'result-group-ko.html',
})
export class ResultGroupKoPage {
  gamePlanList: IGamePlan[] = [];
  tab: string = 'overview';

  /**
   * @todo: big refactoring [ plan -> activePlan]
   */
  @Input() plan: any;
  @Input() activePlan: any;
  @Input() header: boolean = true;
  
  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private gs: TournamentService,
    private actionCtrl: ActionSheetController,
    private translate: TranslateService
  ) {  }

  ionViewDidLoad(){
    this.plan = this.navParams.get('plan') || this.plan;
  }

  onEditTeam(groupIndex: number, pareIndex: number){
    let activePlan = this.gs.planList.findIndex(x => x.name == this.plan.name);
    let modal = this.modalCtrl.create(ResultEditPreRoundPage, { activePlan: activePlan, pareIndex: pareIndex, groupIndex: groupIndex });
    modal.present();
    modal.onDidDismiss(() => {
      if(this.plan.roundPhase){
        this.createRoundGameTable();
      }
    });
  }

  createRoundGameTable(){
    let n = Number(this.plan.groupSize);
  }

  onRemoveTeam(groupIndex: number, pareIndex: number){
    let sheet = this.actionCtrl.create({
      title: this.translate.instant('MYSPORT_PHOTOS_SHEET_TITLE'),
      buttons: [
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_DELETE'),
          role: 'destructive',
          handler: () => {
            this.plan.gameTable[groupIndex].splice(pareIndex, 1);
            this.gs.save();
          }
        },
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    sheet.present();
  }

}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}







// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-group-ko/result-group-ko.ts